import { createSlice } from '@reduxjs/toolkit';

const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState: { 
    theme: 'dark',
    keywordHighlighting: true,
    error:null, 
    success:null, 
    loading:false, 
    action:null,
  },
  reducers: {

    setTheme(state,action){
      state.theme = action.payload;
    },

    setKeywordHighlighting(state, action){
      state.keywordHighlighting = action.payload;
    },

  }
})

export const { selectSample
  , setTheme
  , setKeywordHighlighting
} = settingsSlice.actions

export default settingsSlice.reducer;

// export default undoable(settingsSlice.reducer,{
//   limit: 20 // set a limit for the size of the history
// })
